export default "__VITE_ASSET__CJNpWlS3__"